import { LazyMotion, domAnimation } from 'framer-motion';
import { useMarketplaceHero } from './useMarketplaceHero';
import { BannerCarousel } from './BannerCarousel';
import { HeroTileRow } from './HeroTileRow';

function HeroSkeleton() {
  return <div className="animate-pulse rounded-2xl bg-surface-card h-[220px] sm:h-[300px] lg:h-[380px]" />;
}

export function Hero() {
  const { data, loading } = useMarketplaceHero();

  return (
    <LazyMotion features={domAnimation}>
      {/* The header is `position: fixed` at h-16 (64px); pt-24 reserves space. */}
      <section className="pt-24 pb-12 md:pb-16">
        <div className="container-main flex flex-col gap-6 md:gap-8">
          {loading ? (
            <HeroSkeleton />
          ) : (
            <BannerCarousel banners={data?.banners ?? []} />
          )}
        </div>

        {!loading && (
          <div className="container-main mt-6 md:mt-8">
            <HeroTileRow tiles={data?.tiles ?? []} />
          </div>
        )}
      </section>
    </LazyMotion>
  );
}
